const oFeedSectionEmpty = {
  oFeedSectionEmpty: {
    title: {
      assets: 'La academia no tiene cursos aún.',
      maps: 'La academia no tiene mapas aún.'
    }
  }
}

export default oFeedSectionEmpty
